import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p468700597480255488',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
